import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  pure: false,
})
export class TimeAgoPipe implements PipeTransform {
  private cacheMinute = -1;
  private readonly cache = new Map<string, string>();

  constructor(private readonly translate: TranslateService) {}

  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const now = Date.now();
    const currentMinute = Math.floor(now / 60000);
    const language = this.translate.currentLang || this.translate.defaultLang || 'en';
    const cacheKey = `${date.getTime()}:${language}`;

    if (currentMinute !== this.cacheMinute) {
      this.cacheMinute = currentMinute;
      this.cache.clear();
    }

    const cached = this.cache.get(cacheKey);

    if (cached) {
      return cached;
    }

    const diffMs = now - date.getTime();

    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;

    const minutes = Math.floor(diffMs / minute);
    const hours = Math.floor(diffMs / hour);
    const days = Math.floor(diffMs / day);

    let result: string;

    if (minutes < 1) {
      result = this.translate.instant('certify.chatbot.timeAgo.justNow');
    } else if (minutes < 60) {
      result = this.translate.instant('certify.chatbot.timeAgo.minutes', { value: minutes });
    } else if (hours < 24) {
      result = this.translate.instant('certify.chatbot.timeAgo.hours', { value: hours });
    } else if (hours < 48) {
      result = this.translate.instant('certify.chatbot.timeAgo.yesterday');
    } else if (days < 7) {
      result = this.translate.instant('certify.chatbot.timeAgo.days', { value: days });
    } else if (days < 30) {
      result = this.translate.instant('certify.chatbot.timeAgo.weeks', { value: Math.floor(days / 7) });
    } else {
      result = new Intl.DateTimeFormat(language, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    }

    this.cache.set(cacheKey, result);

    return result;
  }
}
